import { createListenerMiddleware } from '@reduxjs/toolkit'
import { LERE_DYNAMIC_PRICING_EXCLUSION_COOKIE } from 'lib/lere/lereDynamicPricingEligibility'
import { shouldSetSecureCookie } from 'lib/web/cookieUtils'

export const lereDynamicPricingPersistenceMiddleware = createListenerMiddleware<App.State>()

lereDynamicPricingPersistenceMiddleware.startListening({
  predicate: (_, currentState, previousState) =>
    !!currentState.system.lereDynamicPricingExcluded && !previousState.system.lereDynamicPricingExcluded,
  effect: () => {
    document.cookie = `${LERE_DYNAMIC_PRICING_EXCLUSION_COOKIE}=1; Path=/; SameSite=Lax${shouldSetSecureCookie() ? '; Secure' : ''}`
  },
})
